/*@flow*/
import './tooltip.scss';
/**
 * @class Tooltip
 *
 * The tooltip class — it is used to display the tooltip while drawing
 * This will be depreciated
 *
 * @example
 *
 * ```js
 *    var tooltip = new Tooltip(map);
 * ```
 *
 */
export default class Tooltip {
  // @section Methods for modifying draw state

  map: Leaflet$Map;
  popupPane: HTMLElement;
  visible: boolean;
  container: HTMLElement;
  singleLineLabel: boolean;

  // @method initialize(map): void
  // Tooltip constructor
  constructor(map: Leaflet$Map) {
    this.map = map;
    this.popupPane = map._panes.popupPane;
    this.visible = false;
    this.singleLineLabel = false;

    if (!this.container) {
      this.container = L.DomUtil.create(
        'div',
        'leaflet-draw-tooltip',
        this.popupPane
      );
    }
  }

  enable() {
    this.map.on('mouseover', this.onMouseOver);
    this.map.on('mouseout', this.onMouseOut);
  }

  // @method disable(): void
  // Remove Tooltip DOM and unbind events
  disable() {
    this.map.off('mouseover', this.onMouseOver);
    this.map.off('mouseout', this.onMouseOut);
    this.removeError();
    this.hideTooltip();
  }

  // @method updateContent(labelText): this
  // Changes the tooltip text to string in function call
  updateContent(labelText: ?{ text: string, subtext?: string }): this | Tooltip {
    if (!this.container) {
      return this;
    }
    if (!labelText) {
      this.hideTooltip();
      return this;
    }

    labelText.subtext = labelText.subtext || '';

    // update the vertical position (only if changed)
    if (labelText.subtext.length === 0 && !this.singleLineLabel) {
      L.DomUtil.addClass(this.container, 'leaflet-draw-tooltip-single');
      this.singleLineLabel = true;
    } else if (labelText.subtext.length > 0 && this.singleLineLabel) {
      L.DomUtil.removeClass(this.container, 'leaflet-draw-tooltip-single');
      this.singleLineLabel = false;
    }

    this.container.innerHTML =
      '<div>' +
      labelText.text +
      '</div>' +
      (labelText.subtext.length > 0
        ? '<div class="leaflet-draw-tooltip-subtext">' +
          labelText.subtext +
          '</div>'
        : '');

    if (!labelText.text && !labelText.subtext) {
      this.hideTooltip();
    } else {
      this.showTooltip();
    }

    return this;
  }

  showTooltip() {
    this.visible = true;
    this.container.style.visibility = 'inherit';
  }

  hideTooltip() {
    this.visible = false;
    this.container.style.visibility = 'hidden';
  }

  // @method updatePosition(latlng): this
  // Changes the location of the tooltip
  updatePosition(latlng: Leaflet$LatLng): this {
    let pos = this.map.latLngToLayerPoint(latlng),
      tooltipContainer = this.container;

    if (this.container) {
      if (this.visible) {
        tooltipContainer.style.visibility = 'inherit';
      }
      L.DomUtil.setPosition(tooltipContainer, pos);
    }

    return this;
  }

  // @method showAsError(): this
  // Applies error class to tooltip
  showAsError(): this {
    if (this.container) {
      L.DomUtil.addClass(this.container, 'leaflet-error-draw-tooltip');
    }
    return this;
  }

  // @method removeError(): this
  // Removes the error class from the tooltip
  removeError(): this {
    if (this.container) {
      L.DomUtil.removeClass(this.container, 'leaflet-error-draw-tooltip');
    }
    return this;
  }

  onMouseOut: (() => void) = () => {
    this.container && this.hideTooltip();
  };

  onMouseOver: (() => void) = () => {
    this.container && this.showTooltip();
  };
}
